module.exports = __webpack_public_path__ + "img/ico_d--white.a55f6118.svg";